import { create } from 'zustand';

export type SystemDialogVariant = 'default' | 'danger';

export interface SystemConfirmOptions {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string | null;
  variant?: SystemDialogVariant;
}

interface ActiveSystemDialog extends SystemConfirmOptions {
  id: string;
  resolve: (confirmed: boolean) => void;
}

interface SystemDialogStore {
  activeDialog: ActiveSystemDialog | null;
  confirm: (options: string | SystemConfirmOptions) => Promise<boolean>;
  resolveActive: (confirmed: boolean) => void;
}

function createDialogId() {
  return `dialog_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

export const useSystemDialogStore = create<SystemDialogStore>((set, get) => ({
  activeDialog: null,

  confirm: (options) => {
    const normalizedOptions = typeof options === 'string' ? { message: options } : options;
    const currentDialog = get().activeDialog;
    if (currentDialog) {
      currentDialog.resolve(false);
    }

    return new Promise<boolean>((resolve) => {
      set({
        activeDialog: {
          ...normalizedOptions,
          id: createDialogId(),
          resolve,
        },
      });
    });
  },

  resolveActive: (confirmed) => {
    const currentDialog = get().activeDialog;
    if (!currentDialog) return;

    set({ activeDialog: null });
    currentDialog.resolve(confirmed);
  },
}));

export const systemDialog = {
  confirm: (options: string | SystemConfirmOptions) => useSystemDialogStore.getState().confirm(options),
};
